import { useState } from 'react';
import { Layout, Row, Col } from 'antd';
import { Link, Routes, Route } from 'react-router-dom';

import dayjs from 'dayjs';

import MainPage from './MainPage';
import Prices from './Prices';

import logo from './../../static/img/logo.png';
import iot from './../../static/img/iot.png';

const { Header, Footer, Content } = Layout;

const AppLayout = () => {

  const [isMobile, setIsMobile] = useState(window.innerWidth < 700);
  const [centeredText, setCenteredText] = useState(isMobile ? 'center' : '');
  const [sliderText, setSliderText] = useState('Spoločnosť Digma ponúka komplexné riešenia pre monitoring a správu kotolní ako aj riešenia pre diaľkové odpočty spotreby energií v sieti LoRaWAN.');

  return (
    <Layout>
      <Header style={{ backgroundColor: '#fff' }}>
        <Link to={"/"}>
          <h2 style={{color : 'white', fontSize: '16px' }}>
            <img src={logo} style={{ height : '40px', paddingRight: '0px', width: 'auto', paddingTop: '0px'}} alt='DIGMA'/>
          </h2>
        </Link>
      </Header>
      <Content>
        <Row style={{ backgroundColor: '#cfeff2' }}>
          {isMobile ?
            <>
              <Col span={12} md={12} sm={24} xs={24} style={{ paddingTop: '5%' }}>
                <img src={iot} style={{ width: '100%' }} alt='SLIDER'/>
              </Col>
              <Col span={12} md={12} sm={24} xs={24} style={{ paddingLeft: '5%', paddingRight: '5%', paddingTop: '5%', paddingBottom: '5%' }}>
                <h2 style={{color: '#2e2f5b', fontSize: '26px', lineHeight: '39px', fontWeight: '500', letterSpacing: '0px', textAlign: centeredText }}>
                  {sliderText}
                </h2>
              </Col>
            </>
          :
            <>
              <Col span={12} md={12} sm={24} xs={24} style={{ paddingLeft: '10%', paddingRight: '5%', paddingTop: '8%' }}>
                <h2 style={{color: '#2e2f5b', fontSize: '26px', lineHeight: '39px', fontWeight: '500', letterSpacing: '0px'}}>
                  {sliderText}
                </h2>
              </Col>
              <Col span={12} md={12} sm={24} xs={24} style={{ paddingRight: '25px' }} >
                <img src={iot} style={{ width: '100%' }} alt='SLIDER'/>
              </Col>
            </>
          }
        </Row>

        <Routes>
          <Route path={"/"} element={<MainPage />} exact />
          <Route path={"/cennik"} element={<Prices />} />
        </Routes>

        <Row justify="space-around" align="middle" style={{ backgroundColor: '#cfeff2' }}>
          <Col span={4} md={4} sm={8} xs={24} style={{ paddingTop: '40px', paddingBottom: '20px' }}>
            <Link to={"/"}>
              <h2 style={{color : 'white', fontSize: '16px', textAlign: 'center' }}>
                <img src={logo} style={{ height : '50px', paddingRight: '0px', width: 'auto', paddingTop: '0px'}} alt='DIGMA'/>
              </h2>
            </Link>
          </Col>
          <Col span={6} md={6} sm={8} xs={24} style={{ paddingTop: '40px', paddingBottom: '20px' }}>
            <p style={{ lineHeight: '25px', textAlign: centeredText}}>
              <b>DIGMA s.r.o.</b>
              <br/><br/>
              Liptovská 6848<br/>
              911 08 Trenčín<br/>
              Slovenská republika
              <br/><br/>
              +421 904 937 922<br/>
              digma<span className="zav">digma.sk</span>
            </p>
          </Col>
          <Col span={6} md={6} sm={8} xs={24} style={{ paddingTop: '40px', paddingBottom: '20px' }}>
            <p style={{ lineHeight: '25px', textAlign: centeredText}}>
              <b>Firemné údaje</b>
              <br/><br/>
              IČO: 53 818 393<br/>
              IČ DPH: SK2121503395
              <br/><br/>
              Zápis v obchodnom registri:<br/>
              Okresný súd Trenčín<br/>
              oddiel: Sro, vložka č. 41963/R
            </p>
          </Col>
        </Row>
      </Content>
      
      <Footer>
        <Row justify="space-around" align="middle">
          <Col>
            <p style={{ lineHeight: '0px', paddingTop: '15px'}}>&copy; { dayjs().year() } DIGMA s.r.o.</p>
          </Col>
        </Row>
      </Footer>
    </Layout>
  );
}

export default AppLayout;